import { toCents } from './toCents';

// The wallet slot at checkout (Stripe's Payment Request button) is Apple Pay on an
// iPhone or Safari, Google Pay on Android, and Stripe Link in desktop Chrome.
// Apple Pay and Google Pay are one tap with no card or address to type, so they
// lead the payment list; Link alone stays below PayPal, where it always was.
export const walletGoesFirst = (result) => !!(result && (result.applePay || result.googlePay));

// What the wallet sheet shows and authorizes. It must agree to the cent with the
// PaymentIntent the server creates, so it is computed from the CURRENT cart every
// time the cart changes (paymentRequest.update), not once when Stripe loads.
// Stripe rejects a 0 amount, hence the 1-cent floor before the cart has loaded.
export const walletSheetAmounts = (cart, skipShipping) => {
  const amounts = {
    total: {
      label: 'Shoob Photography Purchase Total',
      amount: (cart && toCents(cart.apiTotal)) || 1,
    },
  };
  if (skipShipping) return amounts;

  const shipping = cart && cart.shipping ? Number(cart.shipping) : 0;
  return {
    ...amounts,
    shippingOptions: [
      {
        id: 'shipping',
        label: `Shipping - $${shipping.toFixed(2)}`,
        detail: '',
        amount: toCents(shipping) || 1,
      },
    ],
  };
};
